import AutographComponent from "./components/Autograph";
import AutographStore from "./stores/autographStore";

module.exports = {
  Component: AutographComponent,
  AutographStore
};



// WEBPACK FOOTER //
// ./comMobx/wea-autograph/index.js